import React, { PureComponent } from 'react';
import cn from 'classnames';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { bool, string, func, number, oneOfType, shape, node, instanceOf } from 'prop-types';
import Icon from '../Icon/Icon';
import { isNil } from '../../utils/utils';

class Hint extends PureComponent {
  static propTypes = {
    id: string.isRequired,
    text: oneOfType([string, node]).isRequired,
    open: bool,
    text: oneOfType([string, node]).isRequired,
    placement: string,
    className: string,
    popoverClassName: string,
    delay: oneOfType([shape({ show: number, hide: number }), number]),
    children: node,
    tag: oneOfType([func, string]),
    icon: string,
    container:  oneOfType([instanceOf(Element), string]),
    boundariesElement: instanceOf(Element),
  };

  static defaultProps = {
    open: false,
    title: '',
    text: '',
    placement: 'top',
    tag: 'span',
    icon: 'help-question',
  };

  constructor(props) {
    super(props);

    this.state = {
      open: props.open,
    };
  }

  toggle = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  show = () => {
    this.setState(() => ({ open: true }));
  };

  hide = () => {
    this.setState(() => ({ open: false }));
  };

  render() {
    const { open } = this.state;
    const { id, placement, title, text, delay, className, children, tag: Tag, icon, popoverClassName, boundariesElement, container } = this.props;

    return (
      <Tag className={cn('hint', className)} onMouseEnter={this.show} onMouseLeave={this.hide}>
        <Icon id={id} type={icon} />
        <Popover
          delay={delay}
          placement={placement}
          isOpen={open}
          target={id}
          toggle={this.toggle}
          className={cn('hint-popover', popoverClassName)}
          container={container}
          boundariesElement={boundariesElement}>
          {title && <PopoverHeader>{title}</PopoverHeader>}
          <PopoverBody>{isNil(children) ? text : children}</PopoverBody>
        </Popover>
      </Tag>
    );
  }
}

export default Hint;
